import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackLeadClick } from "@/lib/analytics";

// Sends one GA4 page_view per client-side route change and wires delegated
// tel: / WhatsApp / Google-profile click events for the whole document.
export const AnalyticsListener = () => {
  const location = useLocation();

  useEffect(() => {
    // Let the lazy-loaded page set document.title first.
    const t = setTimeout(() => trackPageView(location), 700);
    return () => clearTimeout(t);
  }, [location.pathname, location.search, location.hash]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.addEventListener("click", trackLeadClick, true);
    return () => document.removeEventListener("click", trackLeadClick, true);
  }, []);

  return null;
};
